<template>
  <div
    class="overview"
    data-cy="team-overview"
  >
    <a
      role="button"
      class="edit-btn"
      data-cy="team-edit-btn"
      @click="toggleModal()"
    >
      <i
        class="far fa-edit"
        aria-hidden="true"
      />
    </a>

    <template v-if="team.location">
      <h4>{{ $t('JSON.where') }}</h4>
      <div>{{ team.location.name }}</div>
    </template>

    <h4>{{ $t('JSON.league') }}</h4>
    <p>
      <router-link :to="navigate(team.league.url)">
        {{ team.league.name }}
      </router-link>
    </p>

    <h4>{{ $t('JSON.category') }}</h4>
    <p>
      <router-link :to="navigate(team.category.url)">
        {{ team.category.name }}
      </router-link>
    </p>

    <h4>{{ $t('JSON.region') }}</h4>
    <p>
      <router-link :to="navigate(team.region.url)">
        {{ team.region.name }}
      </router-link>
    </p>

    <h4>{{ $t('JSON.division') }}</h4>
    <p>
      {{ team.division.name }}
    </p>

    <h4>{{ $t('JSON.tournaments') }}</h4>
    <ul v-if="team.tournaments.length > 0">
      <li
        v-for="(tournament, key) in team.tournaments"
        :key="key"
      >
        <router-link
          :to="navigate(tournament.url)"
          :title="`${tournament.name} (${currentSeason})`"
        >
          {{ tournament.name }}
        </router-link>
      </li>
    </ul>
    <p v-else>
      {{ $t('JSON.none') }}
    </p>

    <h4>
      <router-link :to="navigate(`${team.url}/stats`)">
        <i class="fas fa-chart-bar" />&nbsp; {{ $t('JSON.stats') | ucfirst }}
      </router-link>
    </h4>

    <h4>
      <a
        v-if="team.website && team.website.length > 0"
        :href="team.website"
        target="_blank"
        role="button"
        class="website"
      >
        <i
          class="fas fa-link"
          aria-hidden="true"
        />&nbsp; {{ $t('JSON.website') | ucfirst }}
      </a>
      <a
        v-else
        role="button"
        class="website"
        @click="addTeamLink()"
      >
        <i
          class="fas fa-link"
          aria-hidden="true"
        />&nbsp; {{ $t('JSON.add-website') | ucfirst }}
      </a>
    </h4>

    <h4>
      <a
        role="button"
        class="add-favorite"
        @click="toggleLike()"
      >
        <i
          :class="favoriteClass"
          aria-hidden="true"
        />&nbsp; {{ $t('JSON.add-to-favorites') }}
      </a>
    </h4>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {

  props: {
    team: {
      type: Object,
      default: () => ({}),
    },
    teamLiked: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...sync([
      'general/currentSeason', //
      'general/currentSeasonId',
    ]),

    favoriteClass() {
      return this.teamLiked.status ? 'fas fa-star' : 'far fa-star';
    },
  },

  methods: {
    addTeamLink() {
      Bus.$emit('confirm-box:show', {
        title: `${this.$i18n.t('JSON.does-this-team-have-a-website')}?`,
        body: this.$i18n.t('JSON.click-ok-to-edit-this-team-and-add-its-current-website'),
        size: 'md',
        hookThen: (value) => {
          if (value === true) {
            this.toggleModal();
          }
        },
      });
    },

    toggleModal() {
      Bus.$emit('modal-with-model:toggle', 'team', this.team.id);
    },

    toggleLike() {
      if (this.isLoggedIn()) {
        this.$http.post(`/api/v1/teams/${this.team.id}/like`).then(() => {
          Bus.$emit('refresh_team_following');
        });
      }
    },
  },
};
</script>
